/** PNG 标准 CRC-32（多项式 0xEDB88320） */

const TABLE = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) {
      c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    }
    t[n] = c >>> 0;
  }
  return t;
})();

export function crc32(data: Uint8Array): number {
  let c = 0xffffffff;
  for (let i = 0; i < data.length; i++) {
    c = TABLE[(c ^ data[i]!) & 0xff]! ^ (c >>> 8);
  }
  return (c ^ 0xffffffff) >>> 0;
}

/** PNG chunk CRC = crc32(type || data) */
export function pngChunkCrc(type: Uint8Array, data: Uint8Array): number {
  const buf = new Uint8Array(type.length + data.length);
  buf.set(type, 0);
  buf.set(data, type.length);
  return crc32(buf);
}
